import { render, staticRenderFns } from "./ProdCenter.vue?vue&type=template&id=f1c86acc&"
import script from "./ProdCenter.vue?vue&type=script&lang=js&"
export * from "./ProdCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProdCenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports